export default {
  'common.cancel': 'Hủy',
  'common.save': 'Lưu',
  'common.create': 'Tạo',
  'common.ok': 'OK',
  'common.confirm': 'Xác nhận',
  'common.note': 'Ghi chú',
  'common.copied': 'Đã sao chép!',
  'common.permanentDelete': 'Xóa vĩnh viễn',
};
